<template>
    <div>
        <v-card>
            <v-toolbar outlined flat>
                <v-subheader class="title">Reportes</v-subheader>

                <v-spacer></v-spacer>
                
                <download-csv
                    :data="records"
                    name="report.csv">
                    <v-btn text color="accent">
                        CSV <v-icon>mdi-download</v-icon>
                    </v-btn>
                </download-csv>
                <!-- <v-btn icon @click="edit = true">
                    <v-icon>mdi-cog</v-icon>
                </v-btn> -->
                <v-btn icon v-if="open" @click="open = false">
                    <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn icon v-else @click="open = true">
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </v-toolbar>
            <div v-if="open">
                <v-chip-group
                    v-model="meter"
                    class="ml-6"
                    active-class="active"
                    >
                    <v-chip v-for="meter in meters" :value="meter.name" :key="meter.name">
                        <span v-if="meter.type === 'consumption'">Consumo</span>
                        <span v-else>Generación</span>
                    </v-chip>
                </v-chip-group>
                <v-data-table
                    v-if="ready && meter"
                    :headers="headers"
                    :items="records"
                    :items-per-page="15"
                ></v-data-table>
                <v-row class="text-center align-center" v-else>
                    <v-col class="py-16" v-if="!ready && meter">
                        <v-progress-circular
                            :indeterminate="true"
                            width="5"
                            size="50"
                            color="accent"
                        ></v-progress-circular>
                    </v-col>
                    <v-col class="py-10 text-center" v-else>
                        <v-icon>mdi-selection-ellipse-arrow-inside</v-icon>
                        <p class="subtitle-2 mt-3">Seleccione un medidor</p>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <datepicker 
            :open="edit" 
            @close="edit = false"
            @newValues="newDates"/>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import datepicker from './datePicker'

export default {
    name: 'tableReport',
    props: ['meters', 'plant'],
    components: { datepicker },
    computed:{
        ...mapGetters({
            getMeter: 'meters/getMeter'
        })
    },
    data() {
        return {
            open: false,
            meter: null,
            headers: [],
            records: [],
            ready: false,
            edit: false,
            type: 'hour'
        }
    },
    methods: {
        ...mapActions({ 
            getSummaryData: 'meters/getSummaryData'
        }),
        async newDates(e){
            try {                
                if(this.type == 'hour'){
                    await this.formatDailyData({ 
                        start: e.start.getTime(),
                        end: e.end.getTime()
                    })
                    return
                }

                await this.formatHistoric({ 
                    start: start.getTime(), 
                    end: end.getTime() 
                })
                return
            } catch (error) {
                console.log(error)
            }
        },
        async newDates(dates){
            try {
                this.ready = false
                this.records = []
                
                let meter_data = this.meters.find( m => m.name === this.meter )

                let data = await this.getSummaryData({
                    meters: [meter_data],
                    type: 'custom',
                    options: {
                        type: dates.type,
                        times:{
                            start: dates.start,
                            end: dates.end
                        }
                    }
                })
                
                if(data.length === 0) return
                
                this.headers = [
                    { text: 'Hora', value: 'date', sort: (one, two) => {
                        const date_one = new Date()
                        const date_two = new Date()
                        const one_split = one.split(' ').map((time, index) => time.split(index === 0 ? '/': ':') )
                        const two_split = two.split(' ').map((time, index) => time.split(index === 0 ? '/': ':') )

                        date_one.setFullYear(one_split[0][2], one_split[0][1], one_split[0][0])
                        date_two.setFullYear(two_split[0][2], two_split[0][1], two_split[0][0])
                        date_one.setHours(...one_split[1])
                        date_two.setHours(...two_split[1])
                        
                        return date_one.getTime() < date_two.getTime() ? -1 : 1;
                    } },
                    { text: 'Medidor', value: 'name' }
                ]
                
                for (let index = 0; index < meter_data.nlines; index++) {
                    this.headers.push({ text: `Amps ${index + 1}`, value: `amps${index + 1}` })
                    this.headers.push({ text: `Watts ${index + 1}`, value: `watts${index + 1}` })
                    this.headers.push({ text: `Volts ${index + 1}`, value: `volts${index + 1}` })
                }
                this.headers.push({ text: 'Kwh', value: 'kwh' })

                this.records = data[0].map( read => {
                    let record = {}
                    let day
                    if(dates.type == 'hour'){
                        day = new Date( 
                            read._id.year, 
                            read._id.month - 1, 
                            read._id.day, 
                            read._id.hour
                        )
                        record.date = day.toLocaleString()
                    }
                    else if(dates.type == 'day'){
                        day = new Date( 
                            read._id.year, 
                            read._id.month - 1, 
                            read._id.day
                        )
                        record.date = day.toLocaleDateString()
                    }
                    else if(dates.type == 'month'){
                        day = new Date( 
                            read._id.year, 
                            read._id.month - 1
                        )
                        record.date = `${day.getMonth() + 1}/${day.getFullYear()}`
                    }
                    
                    record.name = meter_data.name

                    read.lines.forEach( l =>{
                        record[`volts${l.nline}`] = l.volts.avg.toFixed(2)
                        if(parseFloat(record[`volts${l.nline}`]) < 10){
                            record[`amps${l.nline}`] = '0.0'
                            record[`watts${l.nline}`] = '0.0'
                            record[`volts${l.nline}`] = '0.0'
                        }
                        else{
                            record[`amps${l.nline}`] = l.amps.toFixed(2)
                            record[`watts${l.nline}`] = l.watts.toFixed(2)
                        }
                    })

                    record.kwh = read.lines[0].kwht.toFixed(2)
                    return record
                })

                this.ready = true

            } catch (error) {
                console.log(error)
            }
        },
    },
    watch:{
        meter(){
            if(this.meter){
                const now = new Date()
                this.newDates({
                    type: 'hour',
                    end: now,
                    start: new Date(now.getTime() - (1000 * 60 * 60 * 24))
                })
            }else
                this.open = false
        },
        plant(){
            if(!this.meter) this.open = false
        }
    }
}
</script>

<style scoped>
    .title{
        text-transform: uppercase;
        padding: 0px;
        font-size: 0.9rem !important;
        font-weight: bold;
    }
    .active{
        color: var(--v-accent-base) !important;
        background-color: white !important;
        box-shadow: 0 0 16px -9px black;
    }
    .v-chip{
        border-radius: 15px;
        font-size: 12px;
        height: 30px;
    }
    .v-chip:before {
        background-color: unset;
    }
</style>